import service from '@/utils/request'; // createSvcGroup 添加储值卡分类
// @Tags Svc
// @Summary 添加储值卡分组
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairungroupRequest true "添加储值卡分类"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /svcManage/svcBalance/group/create [post]

export var createSvcGroup = function createSvcGroup(data) {
  return service({
    url: '/svcManage/svcGroup/create',
    method: 'post',
    data: data
  });
}; // deleteSvcGroup 删除储值卡分类
// @Tags Svc
// @Summary 删除储值卡分类
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairungroupRequest true "删除储值卡分类"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /svcManage/svcBalance/group/delete [delete]

export var deleteSvcGroup = function deleteSvcGroup(data) {
  return service({
    url: '/svcManage/svcGroup/delete',
    method: 'post',
    data: data
  });
}; // deleteSvcGroupByIds 批量删除储值卡分类
// @Tags Svc
// @Summary 批量删除储值卡分类
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除储值卡分类"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"批量删除成功"}"
// @Router /svcManage/svcBalance/group/deleteByIds [delete]

export var deleteSvcGroupByIds = function deleteSvcGroupByIds(data) {
  return service({
    url: '/svcManage/svcGroup/deleteByIds',
    method: 'post',
    data: data
  });
}; // updateSvcGroup 更新储值卡分类
// @Tags Svc
// @Summary 更新储值卡分类
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairungroupRequest true "更新储值卡分类"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /svcManage/svcBalance/group/update [put]

export var updateSvcGroup = function updateSvcGroup(data) {
  return service({
    url: '/svcManage/svcGroup/update',
    method: 'put',
    data: data
  });
}; // findSvcGroup 查找储值卡分组
// @Tags Svc
// @Summary 查找储值卡分类
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairungroupRequest true "查找储值卡分类"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /svcManage/svcBalance/group/find [get]

export var findSvcGroup = function findSvcGroup(params) {
  return service({
    url: '/svcManage/svcGroup/find',
    method: 'get',
    params: params
  });
}; // getSvcGroupList 分页获取储值卡分组
// @Tags Svc
// @Summary 分页获取储值卡分类数据
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairungroupSearch true "分页获取储值卡分类数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /svcManage/svcGroup/getList [get]

export var getSvcGroupList = function getSvcGroupList(params) {
  return service({
    url: '/svcManage/svcGroup/getList',
    method: 'get',
    params: params
  });
};